module.exports = "/assets/data/2a3c00d4c2f030e22e9d7244c81cbed8-LD3.data.json";